$(function() {
    $('.flashes .close-cancel').on('click touchstart', function () {
        $('.flashes').hide();
    });
    $('.flashes').delay(2000).fadeOut(300);
});